import { TUpdateClientPasswordParams } from 'types/services';
import { m8API } from 'services/production/m8';

export const updateClientPassword = async (
  params: TUpdateClientPasswordParams
) => {
  const { clientId, nextPassword } = params;

  await m8API.admin.setUserPassword({
    idUser: clientId,
    newPassword: nextPassword,
  });
};
